import { dialogTypes } from '@/dialogs'
import { getStore } from '@/store'
import { headerTypes } from '../enums/headerTypes'
import { RowEditorRendererBase } from './rowEditorRendererBase'
import { definitionType as definitionTypeEnum } from '@/enums/definitionType'
import { getExistingUserRowCodes } from '@/store/utils/reportUtils'

// Can't connect these, importing instead
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators } from '@/store/ReportSubmissions'
import { getPureMetadata } from '../core/utils'

class BankEditorRenderer extends RowEditorRendererBase {
  createRow = (value) => {
    getStore().dispatch(actionCreators.createUserRow({ ...getPureMetadata(this.props),
      latinName: 'userRow',
      id: 0,
      code: `[${value}]`,
      isUserRow: true,
      definitionType: definitionTypeEnum.enum.Normal,
      fromDefinitionType: this.props.definitionType,
      parent: null,
      parentId: this.props.parentId,
      headerTemplateId: this.props.reportHeaderTemplateId,
      headerRenderer: null,
      type: headerTypes.Classic,
      order: this.getOrder(),
      row: this.props.row
    }))
  }

  onClick () {
    const store = getStore()
    const state = store.getState()
    const definitionType = this.props.definitionType

    let existingCodes = []
    if (definitionType === definitionTypeEnum.enum.BankDef) {
      existingCodes = getExistingUserRowCodes(state.reportSubmissions.bankDefCodes, this.props.parentId)
    }

    if (definitionType === definitionTypeEnum.enum.BankDefResident) {
      existingCodes = getExistingUserRowCodes(state.reportSubmissions.bankDefResidentCodes, this.props.parentId)
    }

    if (definitionType === definitionTypeEnum.enum.BankDefNonResident) {
      existingCodes = getExistingUserRowCodes(state.reportSubmissions.bankDefNonResidentCodes, this.props.parentId)
    }

    store.dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.bankSelector,
      definitionType,
      existingCodes,
      onAction: (value) => this.createRow(value)
    }))
  }
}

export { BankEditorRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/headers/bankEditorRenderer.js